import React from "react";

const BasicInteriorCleaning = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold">Basic Interior Cleaning</p>
        <ul className="list-disc text-black-500 ">
          <li className="font-bold">Interior Vacuum Cleaning</li>
          <li className="font-bold">Seat Cleaning</li>
          <li className="font-bold">Carpet & Floor Mat Cleaning</li>
        </ul>
      </div>
    </div>
  );
};

export default BasicInteriorCleaning;

